import { createEffect, createEvent, createStore, sample } from 'effector';
import { api, setUnauthorizedHandler, unwrap, type Schemas } from '../../shared/api/client';

export const sessionExpired = createEvent();
export const signedIn = createEvent<Schemas['MeOut']>();

export const checkSessionFx = createEffect(() => unwrap(api.GET('/api/v1/auth/me')));

export const signInFx = createEffect((credentials: Schemas['LoginIn']) =>
  unwrap(api.POST('/api/v1/auth/login', { body: credentials })),
);

export const signOutFx = createEffect(() => unwrap(api.POST('/api/v1/auth/logout')));

export const $user = createStore<Schemas['MeOut'] | null>(null)
  .on(checkSessionFx.doneData, (_, user) => user)
  .on(signInFx.doneData, (_, user) => user)
  .reset(sessionExpired, signOutFx.finally, checkSessionFx.fail);

export const $sessionChecked = createStore(false).on(checkSessionFx.finally, () => true);

sample({ clock: [checkSessionFx.doneData, signInFx.doneData], target: signedIn });

setUnauthorizedHandler(() => {
  sessionExpired();
});
